import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dateFilter'
})
export class DateFilterPipe implements PipeTransform {
  /**
   *
   * @param items
   * @param month
   * @param date
   */
  transform(items: any[], month: number, date: number): any[] {
    if (!items) {
      return [];
    }
    if (!date) {
      return items;
    }
    const monthStr = ('0' + month.toString()).slice(-2);
    const dateStr = ('0' + date.toString()).slice(-2);
    const result = items.filter(it => {
      return it.yoteiDate.slice(-5, -3) === monthStr && it.yoteiDate.slice(-2) === dateStr;
    });
    return result;
  }
}
